export default {
	inOutCubic: [0.645, 0.045, 0.355, 1]
};